import { ComponentPropsWithoutRef, ElementRef, forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useEnvironment } from '../../hooks/env';
import { formatDateOfBirth } from '../../utilities/dateUtilities';

type DateOfBirthDisplayElement = ElementRef<'span'>;
interface DateOfBirthDisplayProps extends ComponentPropsWithoutRef<'span'> {
  dateOfBirth?: string | null;

  fallbackMessage?: string;
}

// eslint-disable-next-line react-x/no-forward-ref -- TODO: Wait! Don't change this file without seeing if you can remove this disable. It was added during a bulk version update, but fixing it would leave the park nicer than you found it.
export const DateOfBirthDisplay = forwardRef<
  DateOfBirthDisplayElement,
  DateOfBirthDisplayProps
>(
  (
    { dateOfBirth, fallbackMessage = '(Not provided)', ...props },
    forwardedRef,
  ) => {
    const { i18n } = useTranslation();
    const { formattingContext } = useEnvironment();

    return (
      <span {...props} ref={forwardedRef}>
        {dateOfBirth
          ? formatDateOfBirth(dateOfBirth, formattingContext, i18n.language)
          : fallbackMessage}
      </span>
    );
  },
);

DateOfBirthDisplay.displayName = 'DateOfBirthDisplay';
